import React, { ReactElement } from 'react';
import SaveWidget from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration/Save';
import useSaveWidgetContainer from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu/Panel/Configuration/Save/useSaveWidgetContainer';

const SaveWidgetContainer = (): ReactElement => {
    const { isLoading, isSaveButtonDisabled, onSave, isSaveButtonShown } = useSaveWidgetContainer();

    return isSaveButtonShown ? <SaveWidget onSave={onSave} isLoading={isLoading} isDisabled={isSaveButtonDisabled} /> : <></>;
};

export default SaveWidgetContainer;
